import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_NOTIFICATIONS_LOADING = 'GET_NOTIFICATIONS_LOADING';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_REJECT = 'GET_NOTIFICATIONS_REJECT';

//* ACTIONS ------------------------------------------------
export const getNotificationsLoading = () => ({ type: GET_NOTIFICATIONS_LOADING });
export const getNotificationsSuccess = (payload) => ({ type: GET_NOTIFICATIONS_SUCCESS, payload });
export const getNotificationsReject = (payload) => ({ type: GET_NOTIFICATIONS_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getNotificationsRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Notifications/web/GetNotifications`, options);
};